import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=7b294550&scoped=true"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"
import style0 from "./InfoBlock.vue?vue&type=style&index=0&id=7b294550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b294550",
  null
  
)

export default component.exports